import type { KeyboardEvent } from "react";
import { StyledSearchField } from "web_myplann/Shared/Components/StyledSearchField";

type Props = {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
	autoFocus?: boolean;
};

export const SearchInput = ({
	value,
	onChange,
	placeholder,
	onKeyDown,
	autoFocus,
}: Props) => (
	<StyledSearchField
		value={value}
		onChange={(event) => onChange(event.target.value)}
		onKeyDown={onKeyDown}
		placeholder={placeholder}
		autoFocus={autoFocus}
		fullWidth
	/>
);
